import React from 'react'
import IconsAuraExp24 from './Images/IconsAuraExp24.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faCircleChevronRight} from '@fortawesome/free-solid-svg-icons';



function ExpCard24() {
  return (

    <div className='ExpPgCard  '>
      
        <p className='ExpPgHExpName'> Celebrations with the under-priviledged </p>
        

        <p className='ExpPgHCat'> CSR </p>
        <p className='ExpPgHCode'> AURAMUSE124 </p>

        

        <div className='IconsAuraExpDiv'>  <img className='IconsAuraExp' src={IconsAuraExp24} /> </div>

        <FontAwesomeIcon className='FaIconCirc' icon={faCircleChevronRight} size="xl" style={{color: " ", }} />
        

    </div>




    
  )
}

export default ExpCard24